import { ReactComponent as MobileDeviceIcon } from '../../../assets/icons/mobile-device.svg';
import TooltipComponent from '../../../components/common/bootstrap-component/tooltip-component';
import usePageTranslation from '../../../hooks/ui/usePageTranslation';
import { getTranslatedTextOrDefault } from '../../../util/util';
import { useMobilePreview } from '../hooks/use-mobile-preview';

export function MobilePreviewToggle() {
  const { isMobilePreview, toggle } = useMobilePreview();
  const PageTranslation = usePageTranslation();
  const translations = Array.isArray(PageTranslation) ? PageTranslation : [];
  const openLabel = getTranslatedTextOrDefault(
    'mobilePreview.open.tooltip',
    translations,
    'Preview this page on a mobile device',
  );
  const closeLabel = getTranslatedTextOrDefault(
    'mobilePreview.close.tooltip',
    translations,
    'Return to normal view',
  );
  const label = isMobilePreview ? closeLabel : openLabel;

  return (
    <div className="bc-mobile-preview-toggle-slot">
      <TooltipComponent title={label} placement="top" showOnFocus={true} hideOnClick={false}>
        <button
          type="button"
          className={`btn btn-light rounded-circle shadow bc-mobile-preview-toggle${isMobilePreview ? ' active' : ''}`}
          aria-label={label}
          aria-pressed={isMobilePreview}
          data-testid="mobile-preview-toggle"
          onClick={toggle}
        >
          <MobileDeviceIcon className="bc-icon" aria-hidden="true" />
        </button>
      </TooltipComponent>
    </div>
  );
}
